import React from 'react';
import PropTypes from 'prop-types';
import NumericConfigInput from './components/NumericConfigInput';
import { LOGIC_FIELDS_SCHEMA } from './utils/logicConfigDomain';

const LogicConfigSection = ({
  masterLogicConfig,
  onLogicChange,
  sending,
}) => {
  return (
    <div className="border-top mt-3 pt-3">
      <h6 className="text-muted small text-uppercase mb-2 font-weight-bold config-preview-section-title">
        Lógica y Tiempos
      </h6>
      <ul className="list-unstyled mb-0 text-dark small">
        {LOGIC_FIELDS_SCHEMA.map((field) => {
          const rawVal = masterLogicConfig ? masterLogicConfig[field.key] : undefined;
          const val = rawVal !== undefined && rawVal !== null
            ? rawVal
            : field.defaultValue;

          return (
            <li key={field.key} className="py-2 border-bottom logic-item-border">
              <div className="d-flex justify-content-between align-items-center font-weight-bold">
                <span>{field.label}</span>
                <div className="d-flex align-items-center">
                  <span className="tooltip-container tooltip-right-align">
                    ⓘ
                    <span className="tooltip-text">{field.tooltip}</span>
                  </span>
                  <NumericConfigInput
                    value={val}
                    min={field.min}
                    max={field.max}
                    unit={field.unit}
                    onChange={(newVal) => onLogicChange(field.key, newVal)}
                    disabled={sending}
                  />
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

LogicConfigSection.propTypes = {
  masterLogicConfig: PropTypes.object.isRequired,
  onLogicChange: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
};

export default LogicConfigSection;
